module.exports = __webpack_public_path__ + "img/cloud-rain.8110d7ef.svg";